/**
 * @generated SignedSource<<135ae3e209c822d447678ccf18e60bfa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MembersChooser_team$data = {
  readonly id: string;
  readonly organization: {
    readonly members: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly user: {
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"User_user">;
          };
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly permissions: {
    readonly teamMemberCreate: {
      readonly allowed: boolean;
    } | null;
  };
  readonly slug: string;
  readonly " $fragmentType": "MembersChooser_team";
};
export type MembersChooser_team$key = {
  readonly " $data"?: MembersChooser_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"MembersChooser_team">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "memberAddSearch"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "teamSelector"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MembersChooser_team",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 10
            },
            {
              "kind": "Literal",
              "name": "order",
              "value": "RELEVANCE"
            },
            {
              "kind": "Variable",
              "name": "search",
              "variableName": "memberAddSearch"
            },
            {
              "kind": "Variable",
              "name": "team",
              "variableName": "teamSelector"
            }
          ],
          "concreteType": "OrganizationMemberConnection",
          "kind": "LinkedField",
          "name": "members",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrganizationMemberEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OrganizationMember",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "User_user"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamPermissions",
      "kind": "LinkedField",
      "name": "permissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Permission",
          "kind": "LinkedField",
          "name": "teamMemberCreate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allowed",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};
})();

(node as any).hash = "589d7514cfc77b769f8347e44d2c5358";

export default node;
